import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MapIcon from "@material-ui/icons/Map";

import ApiTour from "../../../API/ApiTour";
import ApiUser from "../../../API/ApiUser";
import styles from "./analyticsStyles";
import AnalyticsView from "./analyticsView";

class Analytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdmin: false,
      tourIdSelected: -1,
    };
  }

  componentDidMount() {
    document.title = "Statistiques | Landing Zone";

    this.setStateIsAdmin();
  }

  async setStateIsAdmin() {
    let response = await ApiUser.isAdmin();

    if (response.status == 200) {
      this.setState((prevState) => ({
        ...prevState,
        isAdmin: response.data.isAdmin,
      }));
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        <AnalyticsView
          {...this.props}
          classes={classes}
          state={this.state}
          onTourSelection={this.onTourSelection}
          tourIdSelected={this.tourIdSelected}
        />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Analytics);
